/**
 * Finance-owned TanStack Query key factory.
 *
 * Defines deterministic cache keys for finance's own dashboard summary. Every
 * other domain's keys live in that domain's `hooks/query-keys.ts`; a shared,
 * multi-domain factory lives in `src/lib/query-keys.ts`.
 */
export const financeDashboardKeys = {
  all: ["finance-dashboard"] as const,
  summary: () => [...financeDashboardKeys.all, "summary"] as const,
};
